import React from "react"
import { useContent } from "../../context/contentProvider"
import WhiteLogo from "../../images/savor-brands-white.png"

import "./savorReasonLists.css"

export const SavorReasonLists = ({ listTitle, lists, languageVal }) => {
    const { contactSavorReasons } = useContent();

    const renderListItems = (items) => {
        if (!Array.isArray(items)) return null;

        return items.map((item, index) => (
            <p key={index} className="mt-0 mb-5 bold">
                <img src={WhiteLogo} style={{ verticalAlign: 'middle', paddingRight: '5px', width: '20px' }} />
                <span>{item}</span>
            </p>
        ));
    };

    console.log(languageVal)

    return (
        <div className="mt-30 text-white savor-services--wrap">
            <h5 className="mt-0 mb-15">
                <span className="underline-big">
                    {languageVal === 'French' 
                        ? 'Pourquoi Nous ?' : languageVal === 'Spanish'
                            ? '¿Por qué nosotros?' : languageVal === 'Portuguese'
                                ? 'Por que nós?' : languageVal === 'Arabic'
                                    ? 'لماذا نحن؟' : languageVal === 'German'
                                        ? 'Warum wir?' : languageVal === 'Italian'
                                            ? 'Perché Noi?' : languageVal === 'Japanese'
                                                ? '私たちを選ぶ理由' : languageVal === 'Indian - Hindi' 
                                                    ? "हम क्यों?" : 'Why Us?'}
                </span>
            </h5> 
            <div className="savor-services--list">
                {renderListItems(lists) || renderListItems(contactSavorReasons)}
            </div>
        </div>
    )
}
